// Angular
import { Component, Input, Output, EventEmitter } from '@angular/core';

// Afidium
import { INotification, NotificationType } from 'libraries/interfaces/INotification';
import { BookingSearchParameters } from 'app_sasha/shared/models/BookingSearchParameters';
import { ILoader } from 'libraries/component/loader/ILoader';
import { WORDING } from './config/wording';
import { IQuickAccessQueries } from 'app_sasha/shared/interfaces/IDefaultSearchParametersHomeConfig';
import { ILabels } from 'libraries/interfaces/ILabels';

@Component({
    selector: 'booking-saved-searched-summary',
    template: `
        <card *ngIf="quickAccessQueries">
            <div class="card-header-content">
                <h1>{{ quickAccessQueries.title | localized }}</h1>
            </div>
            <div class="card-body-content e2e-list-indicators">
                <notification *ngIf="notification.active" [type]="notification.type">
                    {{ notification.message }}
                </notification>

                <ul *ngIf="!notification.active && !loader.active" class="list">
                    <li *ngFor="let change of quickAccessQueries.lines; let i = index;"
                        class="quickAccessQueries-item list-row">
                        <saved-search [configuration]="change"
                            (onSelectProcessing)="selectProcessing($event)"></saved-search>
                    </li>
                </ul>

                <loader *ngIf="loader.active" [message]="loader.message"></loader>
            </div>
        </card>
    `
})
export class BookingSavedSearchedSummaryComponent {
    @Input()
    public quickAccessQueries: IQuickAccessQueries;

    @Output()
    public readonly onSelectProcessing: EventEmitter<{ processingName: string; params: BookingSearchParameters }> = new EventEmitter();

    public wording: ILabels = WORDING;

    public loader: ILoader = {
        active: false,
        message: null
    };

    public notification: INotification = {
        active: false,
        message: null,
        type: NotificationType.Error,
    };

    public selectProcessing($event: { processingName: string; params: BookingSearchParameters }): void {
        this.loader = {
            active: true,
            message: this.wording.loadingBookings,
        };

        this.onSelectProcessing.emit($event);
    }
}
